/// <amd-module name="VSSUI/Icon" />
export { Icon } from "./Components/Icon/Icon";
export { IIconProps, IconSize } from "./Components/Icon/Icon.Props";
